var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
/*!
 * jQuery UI Autocomplete 1.13.3
 * https://jqueryui.com
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license.
 * https://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: https://api.jqueryui.com/autocomplete/
//>>demos: https://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css

(function (factory) {
  "use strict";

  // Browser globals
  factory(jQuery);
})(function ($) {
  "use strict";

  $.widget("ui.autocomplete", {
    version: "1.13.3",
    defaultElement: "<input>",
    options: {
      appendTo: null,
      autoFocus: false,
      delay: 300,
      minLength: 1,
      position: {
        my: "left top",
        at: "left bottom",
        collision: "none"
      },
      source: null,
      // Callbacks
      change: null,
      close: null,
      focus: null,
      open: null,
      response: null,
      search: null,
      select: null
    },
    requestIndex: 0,
    pending: 0,
    liveRegionTimer: null,
    _create: function () {
      // Some browsers only repeat keydown events, not keypress events,
      // so we use the suppressKeyPress flag to determine if we've already
      // handled the keydown event. #7269
      // Unfortunately the code for & in keypress is the same as the up arrow,
      // so we use the suppressKeyPressRepeat flag to avoid handling keypress
      // events when we know the keydown event was used to modify the
      // search term. #7799
      var suppressKeyPress,
        suppressKeyPressRepeat,
        suppressInput,
        nodeName = (this || _global).element[0].nodeName.toLowerCase(),
        isTextarea = nodeName === "textarea",
        isInput = nodeName === "input";

      // Textareas are always multi-line
      // Inputs are always single-line, even if inside a contentEditable element
      // IE also treats inputs as contentEditable
      // All other element types are determined by whether or not they're contentEditable
      (this || _global).isMultiLine = isTextarea || !isInput && this._isContentEditable((this || _global).element);
      (this || _global).valueMethod = (this || _global).element[isTextarea || isInput ? "val" : "text"];
      (this || _global).isNewMenu = true;
      this._addClass("ui-autocomplete-input");
      (this || _global).element.attr("autocomplete", "off");
      this._on((this || _global).element, {
        keydown: function (event) {
          if ((this || _global).element.prop("readOnly")) {
            suppressKeyPress = true;
            suppressInput = true;
            suppressKeyPressRepeat = true;
            return;
          }
          suppressKeyPress = false;
          suppressInput = false;
          suppressKeyPressRepeat = false;
          var keyCode = $.ui.keyCode;
          switch (event.keyCode) {
            case keyCode.PAGE_UP:
              suppressKeyPress = true;
              this._move("previousPage", event);
              break;
            case keyCode.PAGE_DOWN:
              suppressKeyPress = true;
              this._move("nextPage", event);
              break;
            case keyCode.UP:
              suppressKeyPress = true;
              this._keyEvent("previous", event);
              break;
            case keyCode.DOWN:
              suppressKeyPress = true;
              this._keyEvent("next", event);
              break;
            case keyCode.ENTER:
              // when menu is open and has focus
              if ((this || _global).menu.active) {
                // #6055 - Opera still allows the keypress to occur
                // which causes forms to submit
                suppressKeyPress = true;
                event.preventDefault();
                (this || _global).menu.select(event);
              }
              break;
            case keyCode.TAB:
              if ((this || _global).menu.active) {
                (this || _global).menu.select(event);
              }
              break;
            case keyCode.ESCAPE:
              if ((this || _global).menu.element.is(":visible")) {
                if (!(this || _global).isMultiLine) {
                  this._value((this || _global).term);
                }
                this.close(event);

                // Different browsers have different default behavior for escape
                // Single press can mean undo or clear
                // Double press in IE means clear the whole form
                event.preventDefault();
              }
              break;
            default:
              suppressKeyPressRepeat = true;

              // search timeout should be triggered before the input value is changed
              this._searchTimeout(event);
              break;
          }
        },
        keypress: function (event) {
          if (suppressKeyPress) {
            suppressKeyPress = false;
            if (!(this || _global).isMultiLine || (this || _global).menu.element.is(":visible")) {
              event.preventDefault();
            }
            return;
          }
          if (suppressKeyPressRepeat) {
            return;
          }

          // Replicate some key handlers to allow them to repeat in Firefox and Opera
          var keyCode = $.ui.keyCode;
          switch (event.keyCode) {
            case keyCode.PAGE_UP:
              this._move("previousPage", event);
              break;
            case keyCode.PAGE_DOWN:
              this._move("nextPage", event);
              break;
            case keyCode.UP:
              this._keyEvent("previous", event);
              break;
            case keyCode.DOWN:
              this._keyEvent("next", event);
              break;
          }
        },
        input: function (event) {
          if (suppressInput) {
            suppressInput = false;
            event.preventDefault();
            return;
          }
          this._searchTimeout(event);
        },
        focus: function () {
          (this || _global).selectedItem = null;
          (this || _global).previous = this._value();
        },
        blur: function (event) {
          clearTimeout((this || _global).searching);
          this.close(event);
          this._change(event);
        }
      });
      this._initSource();
      (this || _global).menu = $("<ul>").appendTo(this._appendTo()).menu({
        // disable ARIA support, the live region takes care of that
        role: null
      }).hide()

      // Support: IE 11 only, Edge <= 14
      // For other browsers, we preventDefault() on the mousedown event
      // to keep the dropdown from taking focus from the input. This doesn't
      // work for IE/Edge, causing problems with selection and scrolling (#9638)
      // Happily, IE and Edge support an "unselectable" attribute that
      // prevents an element from receiving focus, exactly what we want here.
      .attr({
        "unselectable": "on"
      }).menu("instance");
      this._addClass((this || _global).menu.element, "ui-autocomplete", "ui-front");
      this._on((this || _global).menu.element, {
        mousedown: function (event) {
          // Prevent moving focus out of the text field
          event.preventDefault();
        },
        menufocus: function (event, ui) {
          var label, item;

          // support: Firefox
          // Prevent accidental activation of menu items in Firefox (#7024 #9118)
          if ((this || _global).isNewMenu) {
            (this || _global).isNewMenu = false;
            if (event.originalEvent && /^mouse/.test(event.originalEvent.type)) {
              (this || _global).menu.blur();
              (this || _global).document.one("mousemove", function () {
                $(event.target).trigger(event.originalEvent);
              });
              return;
            }
          }
          item = ui.item.data("ui-autocomplete-item");
          if (false !== this._trigger("focus", event, {
            item: item
          })) {
            // use value to match what will end up in the input, if it was a key event
            if (event.originalEvent && /^key/.test(event.originalEvent.type)) {
              this._value(item.value);
            }
          }

          // Announce the value in the liveRegion
          label = ui.item.attr("aria-label") || item.value;
          if (label && String.prototype.trim.call(label).length) {
            clearTimeout((this || _global).liveRegionTimer);
            (this || _global).liveRegionTimer = this._delay(function () {
              (this || _global).liveRegion.html($("<div>").text(label));
            }, 100);
          }
        },
        menuselect: function (event, ui) {
          var item = ui.item.data("ui-autocomplete-item"),
            previous = (this || _global).previous;

          // Only trigger when focus was lost (click on menu)
          if ((this || _global).element[0] !== $.ui.safeActiveElement((this || _global).document[0])) {
            (this || _global).element.trigger("focus");
            (this || _global).previous = previous;

            // #6109 - IE triggers two focus events and the second
            // is asynchronous, so we need to reset the previous
            // term synchronously and asynchronously :-(
            this._delay(function () {
              (this || _global).previous = previous;
              (this || _global).selectedItem = item;
            });
          }
          if (false !== this._trigger("select", event, {
            item: item
          })) {
            this._value(item.value);
          }

          // reset the term after the select event
          // this allows custom select handling to work properly
          (this || _global).term = this._value();
          this.close(event);
          (this || _global).selectedItem = item;
        }
      });
      (this || _global).liveRegion = $("<div>", {
        role: "status",
        "aria-live": "assertive",
        "aria-relevant": "additions"
      }).appendTo((this || _global).document[0].body);
      this._addClass((this || _global).liveRegion, null, "ui-helper-hidden-accessible");

      // Turning off autocomplete prevents the browser from remembering the
      // value when navigating through history, so we re-enable autocomplete
      // if the page is unloaded before the widget is destroyed. #7790
      this._on((this || _global).window, {
        beforeunload: function () {
          (this || _global).element.removeAttr("autocomplete");
        }
      });
    },
    _destroy: function () {
      clearTimeout((this || _global).searching);
      (this || _global).element.removeAttr("autocomplete");
      (this || _global).menu.element.remove();
      (this || _global).liveRegion.remove();
    },
    _setOption: function (key, value) {
      this._super(key, value);
      if (key === "source") {
        this._initSource();
      }
      if (key === "appendTo") {
        (this || _global).menu.element.appendTo(this._appendTo());
      }
      if (key === "disabled" && value && (this || _global).xhr) {
        (this || _global).xhr.abort();
      }
    },
    _isEventTargetInWidget: function (event) {
      var menuElement = (this || _global).menu.element[0];
      return event.target === (this || _global).element[0] || event.target === menuElement || $.contains(menuElement, event.target);
    },
    _closeOnClickOutside: function (event) {
      if (!this._isEventTargetInWidget(event)) {
        this.close();
      }
    },
    _appendTo: function () {
      var element = (this || _global).options.appendTo;
      if (element) {
        element = element.jquery || element.nodeType ? $(element) : (this || _global).document.find(element).eq(0);
      }
      if (!element || !element[0]) {
        element = (this || _global).element.closest(".ui-front, dialog");
      }
      if (!element.length) {
        element = (this || _global).document[0].body;
      }
      return element;
    },
    _initSource: function () {
      var array,
        url,
        that = this || _global;
      if (Array.isArray((this || _global).options.source)) {
        array = (this || _global).options.source;
        (this || _global).source = function (request, response) {
          response($.ui.autocomplete.filter(array, request.term));
        };
      } else if (typeof (this || _global).options.source === "string") {
        url = (this || _global).options.source;
        (this || _global).source = function (request, response) {
          if (that.xhr) {
            that.xhr.abort();
          }
          that.xhr = $.ajax({
            url: url,
            data: request,
            dataType: "json",
            success: function (data) {
              response(data);
            },
            error: function () {
              response([]);
            }
          });
        };
      } else {
        (this || _global).source = (this || _global).options.source;
      }
    },
    _searchTimeout: function (event) {
      clearTimeout((this || _global).searching);
      (this || _global).searching = this._delay(function () {
        // Search if the value has changed, or if the user retypes the same value (see #7434)
        var equalValues = (this || _global).term === this._value(),
          menuVisible = (this || _global).menu.element.is(":visible"),
          modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
        if (!equalValues || equalValues && !menuVisible && !modifierKey) {
          (this || _global).selectedItem = null;
          this.search(null, event);
        }
      }, (this || _global).options.delay);
    },
    search: function (value, event) {
      value = value != null ? value : this._value();

      // Always save the actual value, not the one passed as an argument
      (this || _global).term = this._value();
      if (value.length < (this || _global).options.minLength) {
        return this.close(event);
      }
      if (this._trigger("search", event) === false) {
        return;
      }
      return this._search(value);
    },
    _search: function (value) {
      (this || _global).pending++;
      this._addClass("ui-autocomplete-loading");
      (this || _global).cancelSearch = false;
      this.source({
        term: value
      }, this._response());
    },
    _response: function () {
      var index = ++(this || _global).requestIndex;
      return function (content) {
        if (index === (this || _global).requestIndex) {
          this.__response(content);
        }
        (this || _global).pending--;
        if (!(this || _global).pending) {
          this._removeClass("ui-autocomplete-loading");
        }
      }.bind(this || _global);
    },
    __response: function (content) {
      if (content) {
        content = this._normalize(content);
      }
      this._trigger("response", null, {
        content: content
      });
      if (!(this || _global).options.disabled && content && content.length && !(this || _global).cancelSearch) {
        this._suggest(content);
        this._trigger("open");
      } else {
        // use ._close() instead of .close() so we don't cancel future searches
        this._close();
      }
    },
    close: function (event) {
      (this || _global).cancelSearch = true;
      this._close(event);
    },
    _close: function (event) {
      // Remove the handler that closes the menu on outside clicks
      this._off((this || _global).document, "mousedown");
      if ((this || _global).menu.element.is(":visible")) {
        (this || _global).menu.element.hide();
        (this || _global).menu.blur();
        (this || _global).isNewMenu = true;
        this._trigger("close", event);
      }
    },
    _change: function (event) {
      if ((this || _global).previous !== this._value()) {
        this._trigger("change", event, {
          item: (this || _global).selectedItem
        });
      }
    },
    _normalize: function (items) {
      // assume all items have the right format when the first item is complete
      if (items.length && items[0].label && items[0].value) {
        return items;
      }
      return $.map(items, function (item) {
        if (typeof item === "string") {
          return {
            label: item,
            value: item
          };
        }
        return $.extend({}, item, {
          label: item.label || item.value,
          value: item.value || item.label
        });
      });
    },
    _suggest: function (items) {
      var ul = (this || _global).menu.element.empty();
      this._renderMenu(ul, items);
      (this || _global).isNewMenu = true;
      (this || _global).menu.refresh();

      // Size and position menu
      ul.show();
      this._resizeMenu();
      ul.position($.extend({
        of: (this || _global).element
      }, (this || _global).options.position));
      if ((this || _global).options.autoFocus) {
        (this || _global).menu.next();
      }

      // Listen for interactions outside of the widget (#6642)
      this._on((this || _global).document, {
        mousedown: "_closeOnClickOutside"
      });
    },
    _resizeMenu: function () {
      var ul = (this || _global).menu.element;
      ul.outerWidth(Math.max(
      // Firefox wraps long text (possibly a rounding bug)
      // so we add 1px to avoid the wrapping (#7513)
      ul.width("").outerWidth() + 1, (this || _global).element.outerWidth()));
    },
    _renderMenu: function (ul, items) {
      var that = this || _global;
      $.each(items, function (index, item) {
        that._renderItemData(ul, item);
      });
    },
    _renderItemData: function (ul, item) {
      return this._renderItem(ul, item).data("ui-autocomplete-item", item);
    },
    _renderItem: function (ul, item) {
      return $("<li>").append($("<div>").text(item.label)).appendTo(ul);
    },
    _move: function (direction, event) {
      if (!(this || _global).menu.element.is(":visible")) {
        this.search(null, event);
        return;
      }
      if ((this || _global).menu.isFirstItem() && /^previous/.test(direction) || (this || _global).menu.isLastItem() && /^next/.test(direction)) {
        if (!(this || _global).isMultiLine) {
          this._value((this || _global).term);
        }
        (this || _global).menu.blur();
        return;
      }
      (this || _global).menu[direction](event);
    },
    widget: function () {
      return (this || _global).menu.element;
    },
    _value: function () {
      return (this || _global).valueMethod.apply((this || _global).element, arguments);
    },
    _keyEvent: function (keyEvent, event) {
      if (!(this || _global).isMultiLine || (this || _global).menu.element.is(":visible")) {
        this._move(keyEvent, event);

        // Prevents moving cursor to beginning/end of the text field in some browsers
        event.preventDefault();
      }
    },
    // Support: Chrome <=50
    // We should be able to just use this.element.prop( "isContentEditable" )
    // but hidden elements always report false in Chrome.
    // https://code.google.com/p/chromium/issues/detail?id=313082
    _isContentEditable: function (element) {
      if (!element.length) {
        return false;
      }
      var editable = element.prop("contentEditable");
      if (editable === "inherit") {
        return this._isContentEditable(element.parent());
      }
      return editable === "true";
    }
  });
  $.extend($.ui.autocomplete, {
    escapeRegex: function (value) {
      return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    },
    filter: function (array, term) {
      var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), "i");
      return $.grep(array, function (value) {
        return matcher.test(value.label || value.value || value);
      });
    }
  });

  // Live region extension, adding a `messages` option
  // NOTE: This is an experimental API. We are still investigating
  // a full solution for string manipulation and internationalization.
  $.widget("ui.autocomplete", $.ui.autocomplete, {
    options: {
      messages: {
        noResults: "No search results.",
        results: function (amount) {
          return amount + (amount > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate.";
        }
      }
    },
    __response: function (content) {
      var message;
      this._superApply(arguments);
      if ((this || _global).options.disabled || (this || _global).cancelSearch) {
        return;
      }
      if (content && content.length) {
        message = (this || _global).options.messages.results(content.length);
      } else {
        message = (this || _global).options.messages.noResults;
      }
      clearTimeout((this || _global).liveRegionTimer);
      (this || _global).liveRegionTimer = this._delay(function () {
        (this || _global).liveRegion.html($("<div>").text(message));
      }, 100);
    }
  });
  return $.ui.autocomplete;
});
export default {};